import {NgModule} from '@angular/core';
import {FlexLayoutModule} from '@ngbracket/ngx-layout';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { LayoutModule  } from '@progress/kendo-angular-layout';
import { GridModule } from '@progress/kendo-angular-grid';
import { ToolBarModule } from '@progress/kendo-angular-toolbar';
import { NavigationModule } from '@progress/kendo-angular-navigation';
import { IndicatorsModule, BadgeModule } from '@progress/kendo-angular-indicators';
import { ExternalUiTranslationService } from './services/external-ui-translation.service';
import { MessageService } from '@progress/kendo-angular-l10n';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { CalendarModule } from '@progress/kendo-angular-dateinputs';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { ListViewModule } from '@progress/kendo-angular-listview';
import { IntlModule } from '@progress/kendo-angular-intl';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import '@angular/common/locales/global/pl'
import { FileSelectModule, UploadsModule } from '@progress/kendo-angular-upload';
import { CoreModule } from '../core/core.module';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NotificationModule } from '@progress/kendo-angular-notification';
import { MenuModule } from '@progress/kendo-angular-menu';
import { PopupModule } from '@progress/kendo-angular-popup';
import { TooltipModule, PopoverModule } from '@progress/kendo-angular-tooltip';
import { ExcelExportModule } from '@progress/kendo-angular-excel-export';
import { IconsModule } from '@progress/kendo-angular-icons';
import { EditorModule } from '@progress/kendo-angular-editor';

const uiSharedModules = [
  CommonModule,
  RouterModule,
  FormsModule,
  ReactiveFormsModule,
  TranslateModule,
  FlexLayoutModule,
  ButtonsModule,
  InputsModule,
  LabelModule,
  IconsModule,
  EditorModule,
  DropDownsModule,
  LayoutModule,
  GridModule,
  ExcelExportModule,
  IndicatorsModule,
  BadgeModule,
  ToolBarModule,
  NavigationModule,
  DialogsModule,
  CalendarModule,
  DateInputsModule,
  IntlModule,
  FileSelectModule,
  UploadsModule,
  ListViewModule,
  NotificationModule,
  MenuModule,
  PopupModule,
  TooltipModule,
  PopoverModule
];

@NgModule({
  declarations: [
  ],
  imports: [
    uiSharedModules,
    CoreModule,
  ],
  exports: [
    uiSharedModules,
  ],
  providers: [{ provide: MessageService, useClass: ExternalUiTranslationService }],
})
export class ExternalUiSharedModule {
}
